// @ts-nocheck

import { MPRoutesActionTypes } from '../types/actions/routes';

export const openMPView = () => ({ type: MPRoutesActionTypes.OPEN_MP_VIEW });
